import { useNavigate } from 'react-router-dom';
import { Briefcase, Building2 } from 'lucide-react';

export default function RegisterPage() {
  const navigate = useNavigate();

  const handleRoleSelect = (role: 'seeker' | 'employer') => {
    sessionStorage.setItem('selectedRole', role);
    if (role === 'seeker') {
      navigate('/register/seeker');
    } else {
      navigate('/register/company');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: 'var(--color-bg-primary)' }}>
      <div className="w-full max-w-md p-8 space-y-8">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="/logo/frame.png"
            alt="Findr Logo"
            width={120}
            height={120}
          />
        </div>

        {/* Title */}
        <div className="text-center space-y-2">
          <h1
            className="font-bold"
            style={{
              fontSize: 'var(--font-size-title-lg)',
              fontWeight: 'var(--font-weight-bold)',
              color: 'var(--color-text-primary)'
            }}
          >
            Opprett ny konto
          </h1>
          <p style={{ fontSize: 'var(--font-size-body-md)', color: 'var(--color-text-secondary)' }}>
            Velg din rolle for å komme i gang
          </p>
        </div>

        {/* Role Selection */}
        <div className="space-y-4">
          <RoleCard
            icon={Briefcase}
            title="Jeg søker jobb"
            description="Finn din drømmejobb ved å swipe"
            onClick={() => handleRoleSelect('seeker')}
          />

          <RoleCard
            icon={Building2}
            title="Jeg representerer en bedrift"
            description="Finn de beste kandidatene"
            onClick={() => handleRoleSelect('employer')}
          />
        </div>

        {/* Back to Login */}
        <div className="text-center pt-4">
          <button
            type="button"
            onClick={() => navigate('/auth')}
            className="text-sm transition-colors"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            Har du allerede konto? <span style={{ color: 'var(--color-text-primary)', fontWeight: 'var(--font-weight-semibold)' }}>Logg inn</span>
          </button>
        </div>
      </div>
    </div>
  );
}

function RoleCard({
  icon: Icon,
  title,
  description,
  onClick,
}: {
  icon: React.ComponentType<{ className?: string; style?: React.CSSProperties }>;
  title: string;
  description: string;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className="w-full rounded-[var(--radius-md)] p-6 backdrop-blur-[var(--blur-backdrop)] transition-all duration-[var(--motion-duration-medium)] hover:scale-[1.02] active:scale-[0.98]"
      style={{
        backgroundColor: 'var(--color-bg-secondary)',
        border: '1px solid var(--color-border)',
        boxShadow: 'var(--shadow-card)',
      }}
    >
      <div className="flex items-center gap-4">
        <div
          className="flex items-center justify-center w-12 h-12 rounded-[var(--radius-sm)]"
          style={{ background: 'var(--color-bg-accent)' }}
        >
          <Icon className="w-6 h-6" style={{ color: 'var(--color-text-primary)' }} />
        </div>
        <div className="flex-1 text-left">
          <h3
            className="font-semibold"
            style={{
              fontSize: 'var(--font-size-body-lg)',
              fontWeight: 'var(--font-weight-semibold)',
              color: 'var(--color-text-primary)',
            }}
          >
            {title}
          </h3>
          <p style={{ fontSize: 'var(--font-size-body-md)', color: 'var(--color-text-secondary)' }}>
            {description}
          </p>
        </div>
      </div>
    </button>
  );
}

